import { render, staticRenderFns } from "./member.vue?vue&type=template&id=4b04d7ed&scoped=true&"
import script from "./member.vue?vue&type=script&lang=js&"
export * from "./member.vue?vue&type=script&lang=js&"
import style0 from "./member.vue?vue&type=style&index=0&id=4b04d7ed&lang=less&scoped=true&"
import style1 from "./member.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b04d7ed",
  null
  
)

export default component.exports